export type PerformanceScoreLabel =
  | 'Excellent'
  | 'Good'
  | 'Average'
  | 'Need Improvement (Intensive)';

const SCORE_TIER_MAP: Record<PerformanceScoreLabel, string> = {
  Excellent: 'excellent',
  Good: 'good',
  Average: 'average',
  'Need Improvement (Intensive)': 'improvement',
};

/**
 * Matches Excel:
 * IF(D>=90,"EXCELLENT",IF(D>=75,"GOOD",IF(D>=60,"AVERAGE","NEED IMPROVEMENT (Intensive)")))
 */
export function summarizePerformanceScore(
  value: number | string | null | undefined,
): PerformanceScoreLabel | null {
  const numValue = parseFloat(String(value));
  if (!Number.isFinite(numValue)) {
    return null;
  }
  if (numValue >= 90) return 'Excellent';
  if (numValue >= 75) return 'Good';
  if (numValue >= 60) return 'Average';
  return 'Need Improvement (Intensive)';
}

export function getPerformanceScoreTierClass(
  label: string | null | undefined,
): string {
  if (!label) {
    return 'orangehrm-performance-score-label--none';
  }

  const tier = SCORE_TIER_MAP[label as PerformanceScoreLabel] ?? 'none';

  return `orangehrm-performance-score-label--${tier}`;
}

export function formatPerformanceScoreLabel(
  label: string | null | undefined,
): string {
  return label ? label.toUpperCase() : '';
}
